export const MAX_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024; // 5MB
export const MAX_VIDEO_UPLOAD_BYTES = 200 * 1024 * 1024; // 200MB
export const MAX_PRODUCT_UPLOAD_BYTES = 10 * 1024 * 1024; // 10MB per product image/video (server cap)
